module.exports = __webpack_public_path__ + "static/media/iesalud-simple-white.1632db43.svg";